import React, {useState} from 'react'
import TableRow from './TableRow'
import RawTableBody from '@mui/material/TableBody'
import {getItemId} from 'services/utils/tableUtils'
import TableExpand from './TableExpand'

const TableBody = ({
    itemName,
    tableKeys,
    keyTypes,
    keyTranslate,
    externalKeys,
    tableItems,
    tableData,
    rowClickAction,
    allowDelete,
    allowEdit,
    allowExpanded,
    onClickDelete,
    onClickEdit,
    tableName,
    tableActions,
}) => {
    const [expendedCell, setExpendedCell] = useState(null)
    return (
        <RawTableBody>
            {tableData.map((row, index) => {
                const labelId = `enhanced-table-checkbox-${index}`
                return (
                    <TableRow
                        key={labelId}
                        itemName={itemName}
                        tableName={tableName}
                        tableRowData={row}
                        tableKeys={tableKeys}
                        externalKeys={externalKeys}
                        keyTypes={keyTypes}
                        keyTranslate={keyTranslate}
                        rowClickAction={rowClickAction}
                        allowDelete={allowDelete}
                        allowEdit={allowEdit}
                        onClickDelete={onClickDelete}
                        onClickEdit={onClickEdit}
                        onClickExpand={allowExpanded ? setExpendedCell : null}
                        expendedCell={expendedCell}
                        tableActions={tableActions}>
                        <TableExpand
                            item={tableItems.find((item) => getItemId(item) === expendedCell)}
                        />
                    </TableRow>
                )
            })}
        </RawTableBody>
    )
}

export default TableBody
